<p-select
  [(ngModel)]="selectedOption"
  (onChange)="onSelectionChange($event)"
  [options]="options"
  optionLabel="value"
  [placeholder]="placeholder"
  [class]="'custom-select'"
  [styleClass]="'w-full md:w-48'"
/>